import React, { Component } from "react";
import {
    Row,
    Col,
    Container,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Alert,
    Spinner,
    FormFeedback
} from "reactstrap";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import FileUploader from '../../components/fileUploader/fileUploader';
import UploadFilesService from '../../services/UploadFilesService';
import TeachingLevelService from '../../services/TeachingLevelService';
import SchoolWorkService from '../../services/SchoolWorkService';
import SchoolService from '../../services/SchoolService';
import './uploadCompetence.css';


import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";


class UploadCompetence extends Component {

    constructor(props) {
        super(props);
        this.state = {
            competence: "LIT",
            isLoading: false,
            schools: [],
            levels: [],
            validation: {},
            selectedSchool: null,
            level: null,
            error: false,
            success: false,
            uploading: false
        };

        this.uploadFilesService = new UploadFilesService();
        this.teachingLevelService = new TeachingLevelService();
        this.schoolService = new SchoolService();
        this.schoolWorkService = new SchoolWorkService();

        this.sendHandler = this.sendHandler.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.onSuccessDismiss = this.onSuccessDismiss.bind(this);
        this.handleSchoolSearch = this.handleSchoolSearch.bind(this);
        this.handleSelectedSchool = this.handleSelectedSchool.bind(this);
    }

    async componentDidMount() {
        await this.handleGetTeachingLevels();
    }

    onDismiss() {
        this.setState({ error: false });
    }

    onSuccessDismiss() {
        this.setState({ success: false });
    }

    handleCleanForm() {
        this.refs.fileUploaderComponent.clearFiles();
        this.refs.refschools.clear();
        this.setState({ theme: '' });
    }

    handleSelectedSchool(selected) {
        if (selected.length > 0)
            this.setState({
                selectedSchool: selected[0]
            });
    }

    async handleSchoolSearch(query) {
        this.setState({ isLoading: true });
        const response = await this.schoolService.search({ name: query });
        this.setState({ schools: response.data.schools, isLoading: false });
    }

    async handleGetTeachingLevels() {
        const levels = await this.teachingLevelService.get();
        this.setState({ levels: levels.data.levels });
    }

    validate() {
        let errors = {};
        if (!this.state.grade)
            errors.grade = { error: true };

        if (!this.state.selectedSchool)
            errors.school = { error: true };

        if (!this.state.level)
            errors.level = { error: true };

        if (!this.state.theme)
            errors.theme = { error: true };

        this.setState({ validation: errors });
        return Object.keys(errors).length > 0;
    }

    async sendHandler() {
        this.setState({ uploading: true });

        if (this.validate()) {
            this.setState({ uploading: false });
            return;
        }

        let files = this.refs.fileUploaderComponent.getFiles();
        if (!files) {
            this.setState({ error: true, message: "Você precisa selecionar um ou mais arquivos para enviar." });
        } else {
            const presignedData = await this.uploadFilesService.getPresignedPostData(this.state.competence, files);
            await this.uploadFilesService.upload(presignedData, files);
            const response = await this
                .schoolWorkService
                .sendWork({
                    school: this.state.selectedSchool.id,
                    level: this.state.level,
                    grade: this.state.grade,
                    theme: this.state.theme,
                    competence: this.state.competence,
                    urls: presignedData.data.presigned.map((item) => `${item.presignedData.url}/${item.presignedData.fields.key}`)
                });
            if (response.data.success)
                this.handleCleanForm();

            this.setState({ success: true, message: "Arquivos enviados com sucesso." });
            setTimeout(() => {
                this.onSuccessDismiss();
            }, 8000);
        }
        this.setState({ uploading: false });
    }

    render() {
        return (
            <div>
                <Row className="bg-dark">
                    <Col>
                        <Container className="container-request">
                            <h2 className="form-title">Upload de arquivos</h2>
                            <Form>
                                <div className="col-12">
                                    <div className="col-8 center">
                                        <FormGroup>
                                            <Label for="school">Escola: </Label>
                                            <AsyncTypeahead
                                                id="school"
                                                labelKey="name"
                                                emptyLabel="Nenhuma escola encontrada"
                                                promptText="Digite para pesquisar"
                                                searchText="Buscando escolas..."
                                                ref='refschools'
                                                isInvalid={!!this.state.validation.school}
                                                useCache={false}
                                                isLoading={this.state.isLoading}
                                                minLength={3}
                                                onSearch={this.handleSchoolSearch}
                                                options={this.state.schools}
                                                onChange={this.handleSelectedSchool}
                                            />
                                            <FormFeedback className={`${!!this.state.validation.school ? 'show-error' : ''}`} invalid>Selecione uma escola!</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="select-teaching-level">Nível de ensino: </Label>
                                            <Input
                                                onChange={(e) => this.setState({ level: `${e.target.value}` })}
                                                type="select"
                                                name="select-teaching-level"
                                                id="select-teaching-level"
                                                invalid={!!this.state.validation.level}>>
                                                <option selected="true" disabled="disabled" value="">Selecione</option>
                                                {this.state.levels.map((ele) => {
                                                    return (
                                                        <option value={ele.id}>{ele.level}</option>
                                                    )
                                                })}
                                            </Input>
                                            <FormFeedback>Selecione um nível de ensino!</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="select-teaching-level">Série: </Label>
                                            <Input
                                                onChange={(e) => this.setState({ grade: `${e.target.value}` })}
                                                type="select"
                                                name="select-teaching-level"
                                                id="select-teaching-level"
                                                invalid={!!this.state.validation.grade}>
                                                <option selected="true" disabled="disabled" value="">Selecione</option>
                                                {[...Array(9).keys()].map((i) => {
                                                    i = ++i;
                                                    return (
                                                        <option value={i}>{i}</option>
                                                    )
                                                })}
                                            </Input>
                                            <FormFeedback >Selecione a série correspondente!</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="select-comp">Atividade: </Label>
                                            <Input
                                                type="text"
                                                invalid={!!this.state.validation.theme}
                                                onChange={(e) => this.setState({ theme: `${e.target.value}` })}
                                                value={this.state.theme} />
                                            <FormFeedback >A Atividade é obrigatório!</FormFeedback>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="select-comp">Selecione a competência: </Label>
                                            <Input
                                                onChange={(e) => this.setState({ competence: `${e.target.value}` })}
                                                type="select"
                                                name="select-comp"
                                                id="select-comp">
                                                <option value="LIT">LIT - Linguagens e suas tecnologias</option>
                                                <option value="MTT">MTT - Matemática e suas tecnologias</option>
                                                <option value="CNT">CNT - Ciências da natureza e suas tecnologias</option>
                                                <option value="CHSA">CHSA - Ciências humanas e sociais aplicadas</option>
                                                <option value="FTP">FTP - Formação técnica e profissional</option>
                                            </Input>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>Selecione seus arquivos utilizando o campo abaixo: </Label>
                                            <FileUploader ref={"fileUploaderComponent"}></FileUploader>
                                        </FormGroup>
                                        <div className="col-12 center">
                                            <Alert color="danger" isOpen={this.state.error || false} toggle={this.onDismiss}>
                                                {this.state.message}
                                            </Alert>
                                            <Alert color="success" isOpen={this.state.success || false} toggle={this.onSuccessDismiss}>
                                                {this.state.message}
                                            </Alert>
                                            {this.state.uploading ?
                                                <Spinner className="center-loading" animation="border" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </Spinner> :
                                                <Button onClick={this.sendHandler} color="primary" type="button" size="lg" block className="mt-4 mb-5 borderRadius10">
                                                  <FontAwesomeIcon icon={faCloudUploadAlt} size="lg" />  Enviar
                                                </Button>}
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </Container>
                    </Col>
                </Row>
            </div >
        );
    }
}

export default UploadCompetence;
